<template>
  <div class="p-3 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen font-sans">
    <!-- Header -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4 bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="flex items-center space-x-3">
        <div class="h-10 w-1.5 bg-gradient-to-b from-red-500 to-rose-600 rounded-full"></div>
        <div>
          <h1 class="text-xl md:text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
            <Icon icon="mdi:cash-minus" class="text-red-600 dark:text-red-400" />
            Gestión de Gastos
          </h1>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 flex items-center">
            <Icon icon="mdi:finance" class="mr-1 text-red-500" />
            Control y seguimiento de gastos operativos
          </p>
        </div>
      </div>
      <button
        @click="openCreateModal"
        class="bg-red-600 hover:bg-red-700 text-white px-4 py-2.5 rounded-xl font-bold transition-all shadow-md shadow-red-200 dark:shadow-none flex items-center gap-2 text-sm md:text-base"
      >
        <Icon icon="mdi:plus-circle" class="text-lg" />
        Nuevo Gasto
      </button>
    </div>

    <!-- Resumen Rápido -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-6">
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 md:p-4 shadow-sm border border-gray-200 dark:border-gray-700">
        <p class="text-[10px] font-black text-gray-400 uppercase">Total Gastos</p>
        <p class="text-xl md:text-2xl font-black text-gray-800 dark:text-white">${{ totalGastos.toFixed(2) }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 md:p-4 shadow-sm border border-gray-200 dark:border-gray-700">
        <p class="text-[10px] font-black text-gray-400 uppercase">Registros</p>
        <p class="text-xl md:text-2xl font-black text-gray-800 dark:text-white">{{ gastos.length }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 md:p-4 shadow-sm border border-gray-200 dark:border-gray-700">
        <p class="text-[10px] font-black text-gray-400 uppercase">Hoy</p>
        <p class="text-xl md:text-2xl font-black text-emerald-600">${{ totalHoy.toFixed(2) }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 md:p-4 shadow-sm border border-gray-200 dark:border-gray-700">
        <p class="text-[10px] font-black text-gray-400 uppercase">Mes</p>
        <p class="text-xl md:text-2xl font-black text-indigo-600">${{ totalMes.toFixed(2) }}</p>
      </div>
    </div>

    <!-- Resumen por Período -->
    <div class="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
      <div class="flex flex-wrap gap-3 items-center">
        <div class="flex items-center gap-2">
          <Icon icon="mdi:calendar-range" class="text-gray-400 text-xl" />
          <span class="text-sm font-bold text-gray-600 dark:text-gray-400">Resumen:</span>
        </div>
        <button
          @click="cargarResumen('dia')"
          :class="['px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-[10px] md:text-xs font-bold transition-all', resumenActivo === 'dia' ? 'bg-red-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600']"
        >
          📅 Hoy
        </button>
        <button
          @click="cargarResumen('semana')"
          :class="['px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-[10px] md:text-xs font-bold transition-all', resumenActivo === 'semana' ? 'bg-red-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600']"
        >
          📆 Semana
        </button>
        <button
          @click="cargarResumen('mes')"
          :class="['px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-[10px] md:text-xs font-bold transition-all', resumenActivo === 'mes' ? 'bg-red-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600']"
        >
          📊 Mes
        </button>
        <button
          @click="imprimirReporte"
          class="px-3 md:px-4 py-1.5 md:py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-[10px] md:text-xs font-bold transition-all flex items-center gap-1 md:gap-2 ml-auto"
        >
          <Icon icon="mdi:printer" class="text-base md:text-lg" />
          <span class="hidden sm:inline">Imprimir</span>
        </button>
        <button
          @click="exportarExcel"
          class="px-3 md:px-4 py-1.5 md:py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-[10px] md:text-xs font-bold transition-all flex items-center gap-1 md:gap-2"
        >
          <Icon icon="mdi:file-excel" class="text-base md:text-lg" />
          <span class="hidden sm:inline">Excel</span>
        </button>
        <button
          @click="exportarPDF"
          class="px-3 md:px-4 py-1.5 md:py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-[10px] md:text-xs font-bold transition-all flex items-center gap-1 md:gap-2"
        >
          <Icon icon="mdi:file-pdf" class="text-base md:text-lg" />
          <span class="hidden sm:inline">PDF</span>
        </button>
      </div>

      <!-- Detalle del Resumen -->
      <div v-if="resumenData" class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        <div class="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-3">
          <p class="text-[10px] font-black text-gray-400 uppercase mb-2">Por Categoría</p>
          <div v-for="(total, cat) in resumenData.resumenPorCategoria" :key="cat" class="flex justify-between text-xs md:text-sm py-1 border-b border-gray-100 dark:border-gray-700 last:border-0">
            <span class="text-gray-600 dark:text-gray-300 font-medium truncate max-w-[120px] md:max-w-[200px]">{{ cat }}</span>
            <span class="font-bold text-gray-800 dark:text-white">${{ total.toFixed(2) }}</span>
          </div>
          <div v-if="Object.keys(resumenData.resumenPorCategoria).length === 0" class="text-xs text-gray-400 italic">Sin datos</div>
        </div>
        <div class="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-3">
          <p class="text-[10px] font-black text-gray-400 uppercase mb-2">Por Método de Pago</p>
          <div v-for="(total, metodo) in resumenData.resumenPorMetodoPago" :key="metodo" class="flex justify-between text-xs md:text-sm py-1 border-b border-gray-100 dark:border-gray-700 last:border-0">
            <span class="text-gray-600 dark:text-gray-300 font-medium">{{ metodo }}</span>
            <span class="font-bold text-gray-800 dark:text-white">${{ total.toFixed(2) }}</span>
          </div>
          <div v-if="Object.keys(resumenData.resumenPorMetodoPago).length === 0" class="text-xs text-gray-400 italic">Sin datos</div>
        </div>
        <div class="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-3">
          <p class="text-[10px] font-black text-gray-400 uppercase mb-2">Por Proveedor</p>
          <div v-for="(total, prov) in resumenData.resumenPorProveedor" :key="prov" class="flex justify-between text-xs md:text-sm py-1 border-b border-gray-100 dark:border-gray-700 last:border-0">
            <span class="text-gray-600 dark:text-gray-300 font-medium truncate max-w-[120px] md:max-w-[200px]">{{ prov }}</span>
            <span class="font-bold text-gray-800 dark:text-white">${{ total.toFixed(2) }}</span>
          </div>
          <div v-if="Object.keys(resumenData.resumenPorProveedor).length === 0" class="text-xs text-gray-400 italic">Sin datos</div>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
      <div class="flex flex-wrap gap-3 items-end">
        <div class="flex-1 min-w-[160px] w-full sm:w-auto">
          <label class="block text-[10px] font-black text-gray-400 uppercase mb-1">Buscar</label>
          <input
            v-model="filtroBusqueda"
            type="text"
            placeholder="Nombre o proveedor..."
            class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-xs md:text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
          />
        </div>
        <div class="w-full sm:w-44">
          <label class="block text-[10px] font-black text-gray-400 uppercase mb-1">Categoría</label>
          <select v-model="filtroCategoria" class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-xs md:text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all">
            <option value="">Todas</option>
            <option v-for="cat in categorias" :key="cat" :value="cat">{{ cat }}</option>
          </select>
        </div>
        <div class="flex gap-2">
          <button @click="resetFilters" class="px-3 py-2.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-all" title="Limpiar filtros">
            <Icon icon="mdi:filter-off" class="text-lg" />
          </button>
          <button @click="cargarGastos" class="px-3 py-2.5 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/30 transition-all flex items-center gap-2 text-xs md:text-sm font-bold">
            <Icon icon="mdi:refresh" :class="{'animate-spin': cargando}" />
            <span class="hidden xs:inline">Actualizar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla de Gastos -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="overflow-x-auto custom-scrollbar">
        <table class="w-full text-left">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest">Nombre</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest hidden sm:table-cell">Categoría</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest text-right">Precio</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest text-center hidden xs:table-cell">Cant.</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest text-right">Total</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest hidden md:table-cell">Proveedor</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest hidden lg:table-cell">Fecha</th>
              <th class="px-3 md:px-4 py-3 text-[10px] md:text-xs font-black text-gray-400 uppercase tracking-widest text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
              <td colspan="8" class="px-3 md:px-4 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-else-if="gastosFiltrados.length === 0">
              <td colspan="8" class="px-3 md:px-4 py-8 md:py-12 text-center">
                <Icon icon="mdi:database-off" class="text-4xl md:text-5xl text-gray-300 dark:text-gray-600 mx-auto mb-4" />
                <p class="text-gray-400 dark:text-gray-500 font-bold text-sm md:text-base">No hay gastos registrados</p>
              </td>
            </tr>
            <tr v-for="g in gastosFiltrados" :key="g.idGasto" class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
              <td class="px-3 md:px-4 py-3 md:py-4">
                <div class="font-bold text-xs md:text-sm text-gray-800 dark:text-white">{{ g.nombre }}</div>
                <div class="text-[9px] md:text-[10px] text-gray-400 truncate max-w-[100px] md:max-w-[150px]">{{ g.descripcion || 'Sin descripción' }}</div>
              </td>
              <td class="px-3 md:px-4 py-3 md:py-4 hidden sm:table-cell">
                <span class="px-2 py-0.5 md:px-2.5 md:py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-[8px] md:text-[10px] font-bold text-gray-600 dark:text-gray-300">
                  {{ g.categoriaGasto }}
                </span>
              </td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-right font-bold text-xs md:text-sm text-gray-800 dark:text-white">${{ g.precio.toFixed(2) }}</td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-center text-xs md:text-sm text-gray-800 dark:text-white hidden xs:table-cell">{{ g.cantidad }}</td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-right font-bold text-xs md:text-sm text-red-600 dark:text-red-400">${{ g.total.toFixed(2) }}</td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm text-gray-600 dark:text-gray-300 hidden md:table-cell max-w-[100px] truncate">{{ g.proveedor || '-' }}</td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-xs md:text-sm text-gray-600 dark:text-gray-300 hidden lg:table-cell">{{ formatDate(g.fechaGasto) }}</td>
              <td class="px-3 md:px-4 py-3 md:py-4 text-center">
                <div class="flex justify-center gap-1 md:gap-2">
                  <button @click="openEditModal(g)" class="p-1.5 md:p-2 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 rounded-lg transition-colors" title="Editar">
                    <Icon icon="mdi:pencil" class="text-base md:text-lg" />
                  </button>
                  <button @click="confirmDelete(g)" class="p-1.5 md:p-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg transition-colors" title="Eliminar">
                    <Icon icon="mdi:trash-can" class="text-base md:text-lg" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="gastosFiltrados.length > 0" class="bg-gray-50 dark:bg-gray-700/50 border-t border-gray-200 dark:border-gray-700">
            <tr>
              <td colspan="4" class="px-3 md:px-4 py-3 text-right font-bold text-xs md:text-sm text-gray-800 dark:text-white">Total General:</td>
              <td class="px-3 md:px-4 py-3 text-right font-bold text-xs md:text-sm text-red-600 dark:text-red-400">${{ totalFiltrado.toFixed(2) }}</td>
              <td colspan="3" class="hidden md:table-cell"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- MODAL FORMULARIO - RESPONSIVE -->
    <Teleport to="body">
      <div v-if="showModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 md:p-4 z-[9999] overflow-y-auto" @click.self="showModal = false">
        <div class="bg-white dark:bg-gray-800 w-full max-w-md md:max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-zoomIn my-auto max-h-[95vh] overflow-y-auto">
          <!-- Header -->
          <div class="bg-gradient-to-r from-red-600 to-rose-600 px-4 md:px-6 py-3 md:py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-1.5 md:p-2 bg-white/20 rounded-xl flex-shrink-0">
              <Icon :icon="isEditing ? 'mdi:pencil' : 'mdi:plus-circle'" class="text-white text-lg md:text-xl" />
            </div>
            <div class="flex-1 min-w-0">
              <h3 class="text-sm md:text-base font-bold text-white truncate">{{ isEditing ? 'Editar Gasto' : 'Nuevo Gasto' }}</h3>
            </div>
            <button @click="showModal = false" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all flex-shrink-0">
              <Icon icon="mdi:close" class="text-white text-lg md:text-xl" />
            </button>
          </div>

          <!-- Formulario -->
          <form @submit.prevent="guardarGasto" class="p-4 md:p-6 space-y-3 md:space-y-4">
            <!-- Nombre -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Nombre *</label>
              <input
                v-model="form.nombre"
                type="text"
                required
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                placeholder="Nombre del gasto"
              />
            </div>

            <!-- Descripción -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Descripción</label>
              <textarea
                v-model="form.descripcion"
                rows="2"
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all resize-none"
                placeholder="Descripción detallada..."
              ></textarea>
            </div>

            <!-- Precio y Cantidad -->
            <div class="grid grid-cols-2 gap-3 md:gap-4">
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Precio *</label>
                <input
                  v-model.number="form.precio"
                  type="number"
                  step="0.01"
                  min="0"
                  required
                  class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                  placeholder="0.00"
                  @input="calcularTotal"
                />
              </div>
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Cantidad *</label>
                <input
                  v-model.number="form.cantidad"
                  type="number"
                  min="1"
                  required
                  class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                  @input="calcularTotal"
                />
              </div>
            </div>

            <!-- Total -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Total</label>
              <div class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-100 dark:bg-gray-600 rounded-xl text-sm font-bold text-red-600 dark:text-red-400">
                ${{ form.total.toFixed(2) }}
              </div>
            </div>

            <!-- Categoría -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Categoría *</label>
              <select
                v-model="form.categoriaGasto"
                required
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
              >
                <option value="">Seleccionar categoría...</option>
                <option v-for="cat in categorias" :key="cat" :value="cat">{{ cat }}</option>
              </select>
            </div>

            <!-- Proveedor -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Proveedor</label>
              <input
                v-model="form.proveedor"
                type="text"
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                placeholder="Nombre del proveedor"
              />
            </div>

            <!-- Método de Pago y Referencia -->
            <div class="grid grid-cols-2 gap-3 md:gap-4">
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Método de Pago</label>
                <select
                  v-model="form.metodoPago"
                  class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                >
                  <option value="">Seleccionar...</option>
                  <option value="Efectivo USD">Efectivo USD</option>
                  <option value="Efectivo Bs">Efectivo Bs</option>
                  <option value="Transferencia USD">Transferencia USD</option>
                  <option value="Transferencia Bs">Transferencia Bs</option>
                  <option value="Pago Móvil">Pago Móvil</option>
                  <option value="Punto de Venta">Punto de Venta</option>
                  <option value="Zelle">Zelle</option>
                  <option value="Binance">Binance</option>
                </select>
              </div>
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Referencia</label>
                <input
                  v-model="form.referencia"
                  type="text"
                  class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
                  placeholder="N° de referencia"
                />
              </div>
            </div>

            <!-- Fecha -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Fecha del Gasto</label>
              <input
                v-model="form.fechaGasto"
                type="datetime-local"
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all"
              />
            </div>

            <!-- Observaciones -->
            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Observaciones</label>
              <textarea
                v-model="form.observaciones"
                rows="2"
                class="w-full px-3 md:px-4 py-2.5 md:py-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-red-500 transition-all resize-none"
                placeholder="Observaciones adicionales..."
              ></textarea>
            </div>

            <!-- Botones -->
            <div class="flex flex-col sm:flex-row gap-3 pt-3 md:pt-4 border-t border-gray-100 dark:border-gray-700">
              <button
                type="button"
                @click="showModal = false"
                class="flex-1 py-2.5 md:py-3 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-bold text-sm hover:bg-gray-200 dark:hover:bg-gray-600 transition-all"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="guardando"
                class="flex-[2] bg-gradient-to-r from-red-600 to-rose-600 text-white py-2.5 md:py-3 rounded-xl font-bold text-sm hover:opacity-90 transition-all shadow-lg shadow-red-200 dark:shadow-none flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Icon :icon="guardando ? 'mdi:loading' : 'mdi:content-save'" :class="{'animate-spin': guardando}" class="text-lg" />
                {{ guardando ? 'Guardando...' : (isEditing ? 'Actualizar Gasto' : 'Registrar Gasto') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { Icon } from '@iconify/vue';
import { 
  obtenerGastos, 
  crearGasto, 
  actualizarGasto, 
  eliminarGasto, 
  obtenerCategoriasGasto, 
  obtenerResumenDiario, 
  obtenerResumenSemanal, 
  obtenerResumenMensual
} from '@/api/gastos';
import { imprimirReporteGastos, exportarGastosExcel, exportarGastosPDF } from '@/utils/reporteGastosGenerator';
import Swal from 'sweetalert2';

// State
const gastos = ref([]);
const categorias = ref([]);
const cargando = ref(false);
const guardando = ref(false);
const showModal = ref(false);
const isEditing = ref(false);
const filtroBusqueda = ref('');
const filtroCategoria = ref('');
const resumenActivo = ref('dia');
const resumenData = ref(null);

// Form
const form = reactive({
  idGasto: null,
  nombre: '',
  descripcion: '',
  precio: 0,
  cantidad: 1,
  total: 0,
  proveedor: '',
  categoriaGasto: '',
  metodoPago: '',
  referencia: '',
  fechaGasto: '',
  observaciones: '',
  idUsuario: parseInt(localStorage.getItem('idUsuario') || 1)
});

// Computed
const gastosFiltrados = computed(() => {
  let result = gastos.value;
  
  if (filtroBusqueda.value) {
    const q = filtroBusqueda.value.toLowerCase();
    result = result.filter(g => 
      g.nombre?.toLowerCase().includes(q) ||
      g.proveedor?.toLowerCase().includes(q) ||
      g.descripcion?.toLowerCase().includes(q)
    );
  }
  
  if (filtroCategoria.value) {
    result = result.filter(g => g.categoriaGasto === filtroCategoria.value);
  }
  
  return result;
});

const totalGastos = computed(() => {
  return gastos.value.reduce((sum, g) => sum + (g.total || 0), 0);
});

const totalFiltrado = computed(() => {
  return gastosFiltrados.value.reduce((sum, g) => sum + (g.total || 0), 0);
});

const totalHoy = computed(() => {
  const hoy = new Date().toISOString().split('T')[0];
  return gastos.value
    .filter(g => g.fechaGasto?.startsWith(hoy))
    .reduce((sum, g) => sum + (g.total || 0), 0);
});

const totalMes = computed(() => {
  const now = new Date();
  const mes = now.getMonth();
  const año = now.getFullYear();
  return gastos.value
    .filter(g => {
      if (!g.fechaGasto) return false;
      const date = new Date(g.fechaGasto);
      return date.getMonth() === mes && date.getFullYear() === año;
    })
    .reduce((sum, g) => sum + (g.total || 0), 0);
});

// Toast with methods
const toast = {
  success: (message) => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: 'success',
      title: message,
      customClass: { popup: 'rounded-2xl' }
    });
  },
  error: (message) => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      icon: 'error',
      title: message,
      customClass: { popup: 'rounded-2xl' }
    });
  },
  info: (message) => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: 'info',
      title: message,
      customClass: { popup: 'rounded-2xl' }
    });
  },
  warning: (message) => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: 'warning',
      title: message,
      customClass: { popup: 'rounded-2xl' }
    });
  }
};

// Methods
const cargarGastos = async () => {
  cargando.value = true;
  try {
    const response = await obtenerGastos();
    if (response.success !== false) {
      gastos.value = Array.isArray(response) ? response : (response?.data || []);
    }
  } catch (error) {
    console.error('Error cargando gastos:', error);
    toast.error('Error al cargar gastos');
  } finally {
    cargando.value = false;
  }
};

const cargarCategorias = async () => {
  try {
    const response = await obtenerCategoriasGasto();
    if (response.success !== false) {
      categorias.value = Array.isArray(response) ? response : (response?.data || []);
    }
  } catch (error) {
    console.error('Error cargando categorías:', error);
  }
};

const cargarResumen = async (tipo) => {
  resumenActivo.value = tipo;
  try {
    let response;
    switch (tipo) {
      case 'dia':
        response = await obtenerResumenDiario();
        break;
      case 'semana':
        response = await obtenerResumenSemanal();
        break;
      case 'mes':
        response = await obtenerResumenMensual();
        break;
    }
    if (response.success !== false) {
      resumenData.value = response;
    }
  } catch (error) {
    console.error('Error cargando resumen:', error);
    toast.error('Error al cargar resumen');
  }
};

const calcularTotal = () => {
  form.total = (form.precio || 0) * (form.cantidad || 1);
};

const openCreateModal = () => {
  isEditing.value = false;
  Object.assign(form, {
    idGasto: null,
    nombre: '',
    descripcion: '',
    precio: 0,
    cantidad: 1,
    total: 0,
    proveedor: '',
    categoriaGasto: '',
    metodoPago: '',
    referencia: '',
    fechaGasto: new Date().toISOString().slice(0, 16),
    observaciones: '',
    idUsuario: parseInt(localStorage.getItem('idUsuario') || 1)
  });
  showModal.value = true;
};

const openEditModal = (g) => {
  isEditing.value = true;
  Object.assign(form, {
    ...g,
    fechaGasto: g.fechaGasto ? g.fechaGasto.slice(0, 16) : new Date().toISOString().slice(0, 16)
  });
  showModal.value = true;
};

const guardarGasto = async () => {
  guardando.value = true;
  try {
    const data = { ...form };
    if (data.fechaGasto) {
      data.fechaGasto = new Date(data.fechaGasto).toISOString();
    }
    data.idUsuario = parseInt(localStorage.getItem('idUsuario') || 1);

    let response;
    if (isEditing.value) {
      response = await actualizarGasto(form.idGasto, data);
    } else {
      response = await crearGasto(data);
    }

    if (response.success !== false) {
      toast.success(isEditing.value ? 'Gasto actualizado con éxito' : 'Gasto registrado con éxito');
      showModal.value = false;
      await cargarGastos();
      await cargarResumen(resumenActivo.value);
    } else {
      toast.error(response.error || 'Error al guardar');
    }
  } catch (error) {
    console.error('Error guardando gasto:', error);
    toast.error('Error al guardar el gasto');
  } finally {
    guardando.value = false;
  }
};

const confirmDelete = async (g) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `Se eliminará el gasto "${g.nombre}". Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#f43f5e',
    cancelButtonColor: '#4f46e5',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    try {
      const response = await eliminarGasto(g.idGasto);
      if (response.success !== false) {
        toast.success('Gasto eliminado correctamente');
        await cargarGastos();
        await cargarResumen(resumenActivo.value);
      } else {
        toast.error(response.error || 'Error al eliminar');
      }
    } catch (error) {
      console.error('Error eliminando gasto:', error);
      toast.error('Error al eliminar el gasto');
    }
  }
};

const resetFilters = () => {
  filtroBusqueda.value = '';
  filtroCategoria.value = '';
};

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' });
};

// Reportes
const imprimirReporte = async () => {
  if (gastosFiltrados.value.length === 0) {
    toast.error('No hay gastos para imprimir');
    return;
  }
  await imprimirReporteGastos(gastosFiltrados.value, resumenActivo.value);
};

const exportarExcel = () => {
  if (gastosFiltrados.value.length === 0) {
    toast.error('No hay gastos para exportar');
    return;
  }
  exportarGastosExcel(gastosFiltrados.value);
};

const exportarPDF = () => {
  if (gastosFiltrados.value.length === 0) {
    toast.error('No hay gastos para exportar');
    return;
  }
  exportarGastosPDF(gastosFiltrados.value);
};

// Lifecycle
onMounted(async () => {
  await cargarCategorias();
  await cargarGastos();
  await cargarResumen('dia');
});

// Expose
defineExpose({ cargarGastos, cargarResumen });
</script>

<style scoped>
.animate-zoomIn {
  animation: zoomIn 0.2s ease-out;
}

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.custom-scrollbar::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background: #334155;
}

@media (max-width: 480px) {
  .xs\:table-cell {
    display: none;
  }
}
</style>